<div [ngStyle]="shiftSubmenu" class="dropdown__submenu absolute rounded-lg bg-white py-2xs drop-shadow-1">
  <div [ngStyle]="shiftIndicator" class="dropdown__submenu__indicator"></div>
  <ul>
    <ng-content></ng-content>
  </ul>
</div>
